import { Subscription } from './subscription-types';
import * as subscriptionStatuses from './subscription-statuses-types';
import { SUBSCRIPTION_ACTIVE_STATUSES } from './subscription-statuses-types';

const ONE_S_IN_MS = 1000;

const isAfter = (date1: number, date2: number) => new Date(date1).getTime() > new Date(date2).getTime();

export const isCancelledInactiveSubscription = (subscription: Subscription) => {
  const { status, expirationDate } = subscription;

  if (status !== subscriptionStatuses.CANCELLED) return false;

  return expirationDate && isAfter(Date.now(), expirationDate * ONE_S_IN_MS);
};

export const isSubscriptionActive = (subscription: Subscription) => {
  const { id, status } = subscription;

  return (
    Boolean(id)
    && SUBSCRIPTION_ACTIVE_STATUSES.includes(status)
    && !isCancelledInactiveSubscription(subscription)
  );
};

export const hasActiveSubscription = (subscriptions: Subscription[]) => {
  return subscriptions.some((subscription) => isSubscriptionActive(subscription));
};
